/** Lease models — each value maps 1:1 to the document template variant the Documents
 *  section generates. Set once on the contract (Terms tab) so it isn't re-picked per
 *  document. Shared by ContractTermsCard (the selector) and DocumentsCard (read-only). */
export const LEASE_MODELS: { value: string; label: string }[] = [
  { value: "roz", label: "ROZ — standard residential lease" },
  { value: "vva_a", label: "VvA model A" },
  { value: "vva_b", label: "VvA model B" },
  { value: "vva_c", label: "VvA model C" },
  { value: "vva_d", label: "VvA model D" },
  { value: "company_roz", label: "Company lease (ROZ) — VAT-taxable" },
];

export function leaseModelLabel(value: string | null | undefined): string {
  const known = LEASE_MODELS.find((m) => m.value === value);
  if (known) return known.label;
  // Don't silently relabel an unknown/legacy variant as ROZ — surface the raw value
  // so a mismatch is visible rather than hidden on the field that picks the template.
  return value ? `Unknown model (${value})` : "Not set";
}
